import { render, staticRenderFns } from "./SectionNotes.vue?vue&type=template&id=03693ff1&scoped=true"
import script from "./SectionNotes.vue?vue&type=script&lang=js"
export * from "./SectionNotes.vue?vue&type=script&lang=js"
import style0 from "./SectionNotes.vue?vue&type=style&index=0&id=03693ff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03693ff1",
  null
  
)

export default component.exports